import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "setup-payment-container" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "text-content" }
const _hoisted_4 = { class: "header-title" }
const _hoisted_5 = { class: "tutorial" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]

import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'SetupPaymentDialog',
  props: {
    daysLeft: {},
    startOpen: { type: Boolean, default: false }
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n()
const router = useRouter()

const emit = __emit
const { startOpen, daysLeft } = __props

const isOpen = ref<boolean>(startOpen)

const goToCustomSpendingLimit = (): void => {
  router.push({ name: 'ShopifyCustomSpendingLimit' })
  isOpen.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_gs_button = _resolveComponent("gs-button")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    class: "setup-payment-dialog",
    fullscreen: "",
    "model-value": isOpen.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = 
      (e) => {
        isOpen.value = e
        emit('update:model-value', e)
      }
    )
  }, {
    activator: _withCtx(({ props: activatorProps }) => [
      _renderSlot(_ctx.$slots, "activator", { props: activatorProps })
    ]),
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "close-button",
            variant: "plain",
            onClick: _cache[0] || (_cache[0] = 
            () => {
              isOpen.value = false
              emit('update:model-value', false)
            }
          )
          }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(t)('setup_payment_header')), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h4", null, _toDisplayString(_unref(t)('youre_so_close')), 1),
              _createElementVNode("p", {
                innerHTML: _unref(t)('add_valid_payment_tutorial_body')
              }, null, 8, _hoisted_6),
              _createElementVNode("p", {
                innerHTML: _unref(t)('no_messy_billing')
              }, null, 8, _hoisted_7),
              _createElementVNode("p", {
                innerHTML: _unref(t)('follow_the_link')
              }, null, 8, _hoisted_8)
            ]),
            _createElementVNode("h4", null, _toDisplayString(_unref(t)('setup_payment_note', { count: daysLeft })), 1)
          ]),
          _createVNode(_component_gs_button, {
            disabled: !goToCustomSpendingLimit,
            class: "cta",
            type: "primary",
            size: "large",
            "full-width": "",
            onClick: goToCustomSpendingLimit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('manage_payment_cta')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    _: 3
  }, 8, ["model-value"]))
}
}

})